<template>
  <div>
    <h2>Document Templates</h2>
    <hr>
    <button class="mylisting-button dark-button mb-4" @click="showTemplateModal()">Add Template</button>
    <div v-for="(template, index) in templates" :key="'Template'+index">
      <!-- {{ template }} -->
      <h3>Name: {{ template.name }} <img src="../../../assets/img/icons/edit_icon_simple.svg" @click="showTemplateModal(template)" style="width: 15px;"></h3>
      <h5>User Type: {{ template.type }}</h5>
      <h5>Status Trigger: {{ template.status_trigger }}</h5>
      <h5>Edit Access: {{ template.edit_access }}</h5>
      <!-- <h5 v-if="template.selector2">Category: {{ template.selector2 }}</h5>
      <p class="">Sender Email: {{ template.from_email }}</p>
      <p class="mb-2">Subject: {{ template.subject }}</p>
      <pre>{{ template.body }}</pre> -->
      <hr>
    </div>

    <modal name="template-modal" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5 field-of-fields">
        <h3 v-if="template.id">Edit Template</h3>
        <h3 v-else>Add Template</h3>
        <hr>
        <label style="margin-top: 0;">Name</label>
        <input type="text" class="form-control" placeholder="Give the template a human readable name for your reference" v-model="name">
        <br>
        <div v-for="(field, index) in fields" :key="'Field'+index">
          <p>Field: {{ field }}<span v-if="fieldsRequired[index]">*</span>, Field Tag: [[field{{ index }}]]
            <button class="btn btn-info" @click="showFieldModal(index)" style="float: right;">Edit</button>
            <!-- <button class="btn btn-danger" @click="deleteField(index)" style="float: right;">Delete</button> -->
          </p>
          <hr>
        </div>
        <button class="mylisting-button dark-button" @click="showFieldModal()">Add Field</button>
        <br>

        <p class="mt-4"><strong>Automatic Substitutions</strong></p>
        <p>[[fname]] for first name.</p>
        <p>[[lname]] for last name.</p>
        <p>[[parent2_fname]] for parent 2's first name.</p>
        <p>[[parent2_lname]] for parent 2's last name.</p>
        <p>[[email]] for email.</p>
        <p>[[phone]] for phone.</p>
        <p>[[parent2_email]] for parent 2's email.</p>
        <p>[[parent2_phone]] for parent 2's phone.</p>
        <p>[[date]] for the date the user is signing the document.</p>
        <p>[[address]] for the user's address.</p>
        <p>[[children]] for children's information.</p>

        <!-- <br> -->
        <!-- <label>Subject</label>
        <input type="text" class="form-control" placeholder="" v-model="subject"> -->
        <label>Body</label>
        <!-- <textarea rows="14" v-model="body" class="form-control"></textarea> -->
        <div class="editor">
          <!-- <Modal ref="ytmodal" @onConfirm="addCommand" /> -->
          <editor-menu-bar :editor="descriptionEditor" v-slot="{ commands, isActive }" class="mb-1">
            <div class="menubar">
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold">
                <strong>B</strong>
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic">
                <i>Italics</i>
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline">
                <u>U</u>
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
                Image
              </button> -->
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="uploadImage(commands.image)">
                Image
              </button> -->
              <!-- https://github.com/scrumpy/tiptap/issues/89 -->
              <!-- https://codesandbox.io/s/j3p0z44155 -->
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="openModal(commands.image);">
                Image
              </button> -->
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.paragraph() }" @click.prevent="commands.paragraph">
                p
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 2 })">
                H1
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click.prevent="commands.heading({ level: 3 })">
                H2
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click.prevent="commands.heading({ level: 4 })">
                H3
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list">
                List
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list">
                1. 2. 3...
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
                ""
              </button> -->
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.horizontal_rule() }" @click.prevent="commands.horizontal_rule">
                ---
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
                Undo
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
                Redo
              </button> -->
            </div>
          </editor-menu-bar>
          <editor-content class="editor__content" :editor="descriptionEditor" />
        </div>

        <br>
        <button class="mylisting-button dark-button mb-3" @click="showSignerModal()">Add Signer</button>
        <div v-for="(signer, index) in signers" :key="'Signer'+index">
          <p>Signer {{ index + 1 }}: {{ signer }} <button class="btn btn-info" @click="showSignerModal(index)" style="float: right;">Edit</button><button class="btn btn-danger" @click="deleteSigner(index)" style="float: right;">Delete</button></p>
          <hr>
        </div>
        <br>

        <!-- <p>Use [*fname*] for first name.</p> -->
        <label>Add a signing name on behalf of the organization</label>
        <input type="text" class="form-control" placeholder="" v-model="organizationSigner">
        <div class="row">
          <!-- <div class="col-lg-3">
            <label>Trigger</label>
            <div class="" style="">
              <multiselect
                v-model="type"
                :options="types"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Trigger"
              ></multiselect>
            </div>
          </div> -->
          <div class="col">
            <label>User Type</label>
            <div class="" style="">
              <multiselect
                v-model="type"
                :options="selector1Options"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Type"
              ></multiselect>
            </div>
            <small @click="type = ''" style="cursor: pointer;">Clear</small>
          </div>
          <!-- <div class="col-lg-3">
            <label>Category</label>
            <div class="" style="">
              <multiselect
                v-model="selector2"
                :options="selector2Options"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Category"
              ></multiselect>
            </div>
          </div> -->
          <div class="col">
            <label>Status Trigger</label>
            <div class="" style="">
              <multiselect
                v-model="status"
                :options="statuses"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Status"
              ></multiselect>
            </div>
            <small @click="status = ''" style="cursor: pointer;">Clear</small>
          </div>
          <div class="col">
            <label>Edit Access</label>
            <div class="" style="">
              <multiselect
                v-model="access"
                :options="accesses"
                :multiple="false"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Who has edit access?"
              ></multiselect>
            </div>
            <small @click="access = ''" style="cursor: pointer;">Clear</small>
          </div>

        </div>

        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('template-modal')">Cancel</button>
        <button v-if="!template.id" class="mylisting-button dark-button" @click="postTemplate()" style="float: right;">Create</button>
        <button v-if="template.id" class="mylisting-button dark-button" @click="updateTemplate()" style="float: right;">Update</button>
      </div>
    </modal>

    <modal name="field-modal" width="80%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5">
        <h3 v-if="fieldIndex || fieldIndex === 0">Edit Field</h3>
        <h3 v-else>Add Field</h3>
        <hr>
        <label>Field Label</label>
        <input type="text" class="form-control" v-model="field">
        <div class="form-group form-check mb-1 mt-4">
          <input class="form-check-input" type="checkbox" :value="true" v-model="fieldRequired" style="margin-top: 4px;">
          <label class="form-check-label" style="text-align: left; cursor: pointer; margin-top: 0;" @click="fieldRequired = !fieldRequired">
            This field is required
          </label>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('field-modal')">Cancel</button>
        <button v-if="fieldIndex || fieldIndex === 0" class="mylisting-button dark-button" @click="updateField()" style="float: right;">Update</button>
        <button v-else class="mylisting-button dark-button" @click="addField()" style="float: right;">Add</button>
      </div>
    </modal>

    <modal name="signer-modal" width="80%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5">
        <h3 v-if="signerIndex || signerIndex === 0">Edit Signer</h3>
        <h3 v-else>Add Signer</h3>
        <hr>
        <label>Signer Label</label>
        <input type="text" class="form-control" v-model="signer" placeholder="Eg. Nanny, Client, Mother, etc.">
        <!-- <div class="form-group form-check mb-1 mt-4">
          <input class="form-check-input" type="checkbox" :value="true" v-model="fieldRequired" style="margin-top: 4px;">
          <label class="form-check-label" style="text-align: left; cursor: pointer; margin-top: 0;" @click="fieldRequired = !fieldRequired">
            This field is required
          </label>
        </div> -->
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('signer-modal')">Cancel</button>
        <button v-if="signerIndex || signerIndex === 0" class="mylisting-button dark-button" @click="updateSigner()" style="float: right;">Update</button>
        <button v-else class="mylisting-button dark-button" @click="addSigner()" style="float: right;">Add</button>
      </div>
    </modal>

    <modal name="template-created-modal" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5">
        <h3>Template created.</h3>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('template-created-modal')">Close</button>
      </div>
    </modal>

    <modal name="template-updated-modal" width="90%" height="auto" :scrollable='true' class="" style="z-index: 9999;">
      <div class="p-5">
        <h3>Template updated.</h3>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('template-updated-modal')">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
// import Icon from 'Components/Icon'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Image, // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
} from 'tiptap-extensions'

export default {
  components: {
    EditorContent,
    EditorMenuBar,
    // Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data() {
    return {
      templates: [],
      template: {},

      fields: [],
      // label: {},
      field: '',
      fieldsRequired: [],
      fieldRequired: false,
      fieldIndex: null,

      signers: [],
      signer: '',
      signerIndex: null,
      organizationSigner: '',

      editing: false,

      status: '',
      // statuses: [],
      type: '',
      types: [
        'Status Change Notification',
        // 'Status Reminder',
      ],
      selector1Options: [
        'Candidate', 'Employer',
        // 'Job'
      ],
      selector1: '',
      // selector2Options: [
      //   '',
      // ],
      selector2: '',
      access: '',
      accesses: [
        'Admin',
        // 'User',
        'All'
      ],

      subject: '',
      body: '',
      name: '',
      fromEmail: this.$store.getters.agencyAdminEmail,

      descriptionEditor: null,
    }
  },
  computed: {
    statuses() {
      if (this.type == 'Candidate') {
        return this.$store.getters.candidateStatuses
      }
      else if (this.type == 'Employer') {
        return this.$store.getters.employerStatuses
      }
      else {
        return []
      }
    },
    selector2Options() {
      if (this.selector1 == 'Candidate') {
        return this.$store.getters.candidateTypes
      }
      else if (this.selector1 == 'Employer') {
        return this.$store.getters.employerTypes
      }
      else {
        return []
      }
    },
  },
  created() {
    this.getTemplates()
    // this.statuses = this.$store.getters.statuses
  },
  mounted() {
    this.descriptionEditor = new Editor({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3, 4, 5] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new Image(), // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
      ],
      onUpdate: ({ getJSON, getHTML }) => {
        // this.json = getJSON()
        // this.html = getHTML()
        this.description = getHTML()
      },
    })
  },
  beforeDestroy() {
    this.descriptionEditor.destroy()
  },
  methods: {
    getTemplates() {
      axios.get(`/api/documenttemplates/?agency=${this.$store.getters.agencyID}`)
        .then(res => {
          this.templates = res.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showTemplateModal(template) {
      if (template) {
        this.template = template
        // this.subject = template.subject
        this.status = template.status_trigger
        this.type = template.type
        this.name = template.name
        // this.body = template.body
        // if (template.from_email) {
        //   this.fromEmail = template.from_email
        // }
        // this.selector1 = template.selector1
        // this.selector2 = template.selector2

        this.fields = template.fields
        this.fieldsRequired = template.fields_required
        this.signers = template.signer_labels
        this.organizationSigner = template.organization_signer
        this.access = template.edit_access

        if (template.body) {
          this.descriptionEditor.setContent(template.body)
          this.description = template.body
        } else {
          this.descriptionEditor.setContent('')
          this.description = ''
        }
      }
      else {
        this.template = {}
        this.status = ''
        this.type = ''
        this.name = ''
        this.fields = []
        this.fieldsRequired = []
        this.signers = []
        this.organizationSigner = ''
        this.access = ''
        this.descriptionEditor.setContent('')
      }
      this.$modal.show('template-modal')
    },
    showFieldModal(index) {
      if (index || index == 0) {
        this.field = this.fields[index]
        this.fieldRequired = this.fieldsRequired[index]
        this.fieldIndex = index
        this.$modal.show('field-modal')
      } else {
        this.field = ''
        this.fieldRequired = false
        this.fieldIndex = null
        this.$modal.show('field-modal')
      }
    },
    addField() {
      this.fields.push(this.field)
      this.fieldsRequired.push(this.fieldRequired)
      this.$modal.hide('field-modal')
      this.field = ''
      this.fieldRequired = false
      this.fieldIndex = null
    },
    updateField() {
      this.fields[this.fieldIndex] = this.field
      this.fieldsRequired[this.fieldIndex] = this.fieldRequired
      this.field = ''
      this.fieldRequired = false
      this.fieldIndex = null
      this.$modal.hide('field-modal')
    },
    deleteField(index) {
      this.fields.splice(index, 1)
      this.fieldsRequired.splice(index, 1)
    },
    showSignerModal(index) {
      if (index || index == 0) {
        this.signer = this.signers[index]
        this.signerIndex = index
      }
      else {
        this.signer = ''
        this.signerIndex = null
      }
      this.$modal.show('signer-modal')
    },
    addSigner() {
      this.signers.push(this.signer)
      this.$modal.hide('signer-modal')
      this.signer = ''
      this.signerIndex = null
    },
    updateSigner() {
      this.signers[this.signerIndex] = this.signer
      this.signer = ''
      this.signerIndex = null
      this.$modal.hide('signer-modal')
    },
    deleteSigner(index) {
      this.signers.splice(index, 1)
    },
    postTemplate() {
      axios.post(`/api/documenttemplates/`, {
        name: this.name,
        status_trigger: this.status,
        type: this.type,
        // subject: this.subject,
        body: this.description,
        fields: this.fields,
        fields_required: this.fieldsRequired,
        signer_labels: this.signers,
        organization_signer: this.organizationSigner,
        edit_access: this.access,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          this.getTemplates()
          this.$modal.hide('template-modal')
          this.$modal.show('template-created-modal')
        })
    },
    updateTemplate() {
      axios.patch(`/api/documenttemplates/${this.template.id}/`, {
        name: this.name,
        status_trigger: this.status,
        type: this.type,
        body: this.description,
        fields: this.fields,
        fields_required: this.fieldsRequired,
        signer_labels: this.signers,
        organization_signer: this.organizationSigner,
        edit_access: this.access,
      })
        .then(res => {
          this.getTemplates()
          this.$modal.hide('template-modal')
          this.$modal.show('template-updated-modal')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/systems/DocumentTemplates.vue